<div
  class="select-box"
  [class]="selectType"
  *ngIf="control"
  [class.grc-dropdown]="isGrcDropdown"
>
  <label
    *ngIf="label"
    [ngStyle]="{ 'font-size': labelSize + 'px' }"
    [class.grc-dropdown-label]="isGrcDropdown"
    >{{ label | translate }}
    <span *ngIf="!isGrcDropdown">:</span>
    <mat-error *ngIf="control.errors"> *</mat-error></label
  >
  <mat-form-field
    *ngIf="!group"
    [ngStyle]="{ width: inputWidth ? inputWidth : '' }"
  >
    <mat-label>{{ matLabel }}</mat-label>
    <mat-select
      [formControl]="control"
      [required]="required"
      [panelClass]="'stc-select-panel'"
      (selectionChange)="onChangeValue($event.value)"
      [multiple]="multi"
    >
      <mat-option *ngIf="searchMode" class="searchInput">
        <span class="" id="basic-addon1"><i class="fas fa-search"></i></span>
        <input
          type="text"
          [formControl]="searchControl"
          [placeholder]="'Search...'"
          (click)="stopDropdownClose($event)"
        />
      </mat-option>
      <mat-option
        *ngFor="let option of filteredOptions"
        [value]="
          multi
            ? option[labelValue]
            : outputValue
            ? option[outputValue]
            : option
        "
      >
        {{ option[labelName] }}
      </mat-option>
    </mat-select>
    <button
      mat-icon-button
      matSuffix
      aria-label="Clear selection"
      *ngIf="
        Resetting &&
        hasUserSelection &&
        (multi
          ? isArray(control?.value) && control?.value.length > 0
          : control?.value != null)
      "
      (click)="clearSelection($event)"
    >
      <i class="fas fa-times"></i>
    </button>
    <mat-error *ngIf="control.errors">{{
      'field_required' | translate
    }}</mat-error>
  </mat-form-field>
  <mat-form-field *ngIf="group">
    <mat-select
      [formControl]="control"
      [multiple]="multi"
      [panelClass]="'stc-select-panel'"
      (selectionChange)="onChangeValue($event.value)"
    >
      <mat-option *ngIf="searchMode" class="searchInput">
        <span class="" id="basic-addon1"><i class="fas fa-search"></i></span>
        <input
          [formControl]="searchControl"
          [placeholder]="'Search...'"
          (click)="stopDropdownClose($event)"
        />
      </mat-option>
      <mat-optgroup
        *ngFor="let group of options"
        [label]="group[groupName]"
        [disabled]="group.disabled"
      >
        <mat-option
          *ngFor="let option of group[groupOptions]"
          [value]="option.id"
        >
          {{ option[labelName] }}
        </mat-option>
      </mat-optgroup>
    </mat-select>
    <button
      mat-icon-button
      matSuffix
      aria-label="Clear selection"
      *ngIf="
        Resetting &&
        hasUserSelection &&
        (multi
          ? isArray(control?.value) && control?.value.length > 0
          : control?.value != null)
      "
      (click)="clearSelection($event)"
    >
      <i class="fas fa-times"></i>
    </button>
    <mat-error *ngIf="control.errors">{{
      'field_required' | translate
    }}</mat-error>
  </mat-form-field>
  <div style="display: none" *ngIf="!yet">
    <ng-content></ng-content>
  </div>
</div>
